import HttpClient from './HttpService';

const UPLOAD_ENDPOINT = process.env.VUE_APP_ROOT_UPLOAD_ENDPOINT;

function upload(file, { patientUuid, evolutionUuid, folderType } = {}, onUploadProgress) {
    const formData = new FormData();
    formData.append('files', file);

    const params = new URLSearchParams();
    if (patientUuid) params.set('patient_uuid', patientUuid);
    if (evolutionUuid) params.set('evolution_uuid', evolutionUuid);
    if (folderType) params.set('folder_type', folderType);
    const query = params.toString();
    const endpoint = query ? `${UPLOAD_ENDPOINT}?${query}` : UPLOAD_ENDPOINT;

    return HttpClient.post(endpoint, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress
    });
}

function updateExamDescription(fileId, examDescription) {
    return HttpClient.patch(`/files/${fileId}/exam-description`, { exam_description: examDescription });
}

export default {
    upload,
    updateExamDescription
}
